import * as authStore from "./authStore";

type AuthGetters = {
  getAccessToken?: () => string | null;
  getRefreshToken?: () => string | null | Promise<string | null>;
};

let authGetters: AuthGetters | null = null;

export function setAuthGetters(getters: AuthGetters | null): void {
  authGetters = getters;
}

export function getAccessToken(): string | null {
  if (authGetters?.getAccessToken) {
    const tokenFromContext = authGetters.getAccessToken();
    if (tokenFromContext) {
      return tokenFromContext;
    }
  }

  return authStore.getAccessToken();
}

export function getRefreshToken(): Promise<string | null> {
  if (authGetters?.getRefreshToken) {
    return Promise.resolve(authGetters.getRefreshToken()).then((newToken) => {
      if (newToken) return newToken;
      return authStore.refreshToken();
    });
  }

  return authStore.refreshToken();
}
